import React, { useMemo } from 'react';
import { OptionKey, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION_KEY } from '@/common/constants';
import { useSelectAllHandler } from '@/modules/core';

import { ACCOUNT_TYPE_OPTIONS } from '../../report.types';

interface Props {
  testId?: string;
  values: OptionKey[];
  disabled?: boolean;
  onChangeValues: (value: OptionKey[]) => void;
}
const AccountTypeDropdown: React.FC<Props> = ({
  testId = 'account-type-dropdown',
  disabled,
  values,
  onChangeValues,
}) => {
  const currentValue = useMemo(() => {
    if (!values.length && !disabled) {
      return [ALL_OPTION_KEY];
    }
    return values;
  }, [disabled, values]);

  const handleChangeValue = useSelectAllHandler(values, onChangeValues);

  return (
    <SelectDropdown
      key="account-type"
      ellipsisMode
      disabled={disabled}
      activeTitle
      testId={testId}
      options={ACCOUNT_TYPE_OPTIONS}
      values={currentValue}
      onChangeValues={handleChangeValue}
      prefix="Account type"
      id="account_type"
      name="account-type"
      allMode
      dropdownStyles={{
        width: '320px',
      }}
    />
  );
};

export default AccountTypeDropdown;
